// couponTypes.js — mirror DealCouponz client naming style

export const GET_ALL_COUPONS_REQUEST = "GET_ALL_COUPONS_REQUEST";
export const GET_ALL_COUPONS_SUCCESS = "GET_ALL_COUPONS_SUCCESS";
export const GET_ALL_COUPONS_FAILURE = "GET_ALL_COUPONS_FAILURE";

export const GET_COUPON_BY_ID_REQUEST = "GET_COUPON_BY_ID_REQUEST";
export const GET_COUPON_BY_ID_SUCCESS = "GET_COUPON_BY_ID_SUCCESS";
export const GET_COUPON_BY_ID_FAILURE = "GET_COUPON_BY_ID_FAILURE";

export const GET_TRENDING_COUPONS_REQUEST = "GET_TRENDING_COUPONS_REQUEST";
export const GET_TRENDING_COUPONS_SUCCESS = "GET_TRENDING_COUPONS_SUCCESS";
export const GET_TRENDING_COUPONS_FAILURE = "GET_TRENDING_COUPONS_FAILURE";

export const GET_COUPONS_BY_CATEGORY_SLUG_REQUEST =
  "GET_COUPONS_BY_CATEGORY_SLUG_REQUEST";
export const GET_COUPONS_BY_CATEGORY_SLUG_SUCCESS =
  "GET_COUPONS_BY_CATEGORY_SLUG_SUCCESS";
export const GET_COUPONS_BY_CATEGORY_SLUG_FAILURE =
  "GET_COUPONS_BY_CATEGORY_SLUG_FAILURE";

/** Merge denormalised counters / flags from vote, comment, or like APIs. */
export const MERGE_COUPON = "MERGE_COUPON";
